import { Component, ElementRef, OnInit } from '@angular/core';
import { globals } from '../globals';
import { AutenticacaoService } from '../services/autenticacao.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificacaoService } from '../services/notificacao.service';
import { CarregandoService } from '../services/carregando.service';
import { MatDialog } from '@angular/material';
import { GlobalService } from '../services/global.service';
import { AppConfigService } from '../services/app-config.service';
import { IdentidadeVisualService } from '../services/identidade-visual.service';
import { Subscription } from 'rxjs';
import { Configuracao } from '../models/configuracao';
import { RastreioService } from '../services/rastreio.service';
import { RastreioDTO } from '../models/rastreio-acess';

@Component({
  selector: 'app-rastreio-externo',
  templateUrl: './rastreio-externo.component.html',
  styleUrls: ['./rastreio-externo.component.scss']
})
export class RastreioExternoComponent implements OnInit {
  dados: RastreioDTO = new RastreioDTO();
  idVisual: any;
  token = '';
  idCupom;
  urls = [];
  urlSelecionada = globals.apiUrl;
  podeVerRastreio = false;
  private nativeElement: Node;
  private configuracaoSubscription$: Subscription;
  configuracao: Configuracao;

  constructor(
    private element: ElementRef,
    private autenticacaoService: AutenticacaoService,
    private router: Router,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private globalService: GlobalService,
    private appConfigService: AppConfigService,
    private identidadeVisualService: IdentidadeVisualService,
    private rastreioService: RastreioService,
  ) {
    this.nativeElement = element.nativeElement;
  }

  ngOnInit() {
    try {
      this.urls = this.appConfigService.getServerUrls();

      if (!this.urls.some(p => p === this.urlSelecionada)) {
        this.urlSelecionada = undefined;
      }

      if (this.urls.length === 1) {
        this.urlSelecionada = this.urls[0];
      }

      this.buscarIdentidadeVisual();

      // inscreve no evento de troca de configuração
      this.configuracaoSubscription$ = this.globalService.alterouConfiguracao.subscribe(conf => {
        this.configuracao = conf;
      });

      this.autenticacaoService.logoutLocal();

      // se for edição, busca o instalador do id passado
      if (this.route.snapshot.paramMap.get('token')) {
        this.token = this.route.snapshot.paramMap.get('token');
        this.validandoLink();
      }
      else {
        this.router.navigate(['/']);
      }

      const body = document.getElementsByTagName('body')[0];
      body.classList.add('login-page');
      body.classList.add('off-canvas-sidebar');
      const card = document.getElementsByClassName('card')[0];
      setTimeout(function () {
        // after 1000 ms we add the class animated to the login/register card
        card.classList.remove('card-hidden');
      }, 700);
    } catch (erro) {
      this.notificacaoService.erro("Erro: ");
    }
  }

  buscarIdentidadeVisual() {
    this.carregandoService.mostra('buscarIdentidadeVisual');

    globals.apiUrl = this.urlSelecionada;
    localStorage.setItem('urlApi', this.urlSelecionada);

    this.identidadeVisualService.consultarIdentidadeVisual().subscribe(idVisual => {
      this.idVisual = idVisual;

      localStorage.setItem('idVisual', JSON.stringify(idVisual));

      this.carregandoService.esconde('buscarIdentidadeVisual');
    }, (erro) => {
      this.carregandoService.esconde('buscarIdentidadeVisual');
      this.notificacaoService.erro(erro);
      console.log(erro);
    });
  }

  validandoLink() {
    this.carregandoService.mostra("ValidaLink");

    globals.apiUrl = this.urlSelecionada;
    localStorage.setItem('urlApi', this.urlSelecionada);

    this.rastreioService.validaLink(this.token).subscribe(data => {
      this.carregandoService.esconde("ValidaLink");

      if (data == null)
        this.router.navigate(['/']);

      this.dados = data;
      this.podeVerRastreio = true;
    }, (erro) => {
      this.carregandoService.esconde("ValidaLink");
    });
  }

  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('login-page');
    body.classList.remove('off-canvas-sidebar');

    this.configuracaoSubscription$.unsubscribe();
  }
}
